(() => {
  const key = 'zuqo-wishlist-v1';
  const dialog = document.getElementById('ZuqoWishlist');
  if (!dialog) return;
  const grid = dialog.querySelector('[data-zuqo-wishlist-grid]');
  const empty = dialog.querySelector('[data-zuqo-wishlist-empty]');
  const status = document.querySelector('[data-zuqo-wishlist-status]');
  const safePath = value => typeof value === 'string' && value.startsWith('/') && !value.startsWith('//');
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      if (!Array.isArray(value)) return [];
      return value.filter(item => item && /^\d+$/.test(String(item.id)) && safePath(item.url) && typeof item.title === 'string').slice(0, 200);
    } catch { return []; }
  };
  let items = read();
  const update = (scope = document) => {
    scope.querySelectorAll('[data-zuqo-wishlist-toggle]').forEach(button => {
      const saved = items.some(item => item.id === button.dataset.id);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', `${saved ? 'Remove' : 'Save'} ${button.dataset.title} ${saved ? 'from' : 'to'} wishlist`);
    });
    document.querySelectorAll('[data-zuqo-wishlist-count]').forEach(count => {
      count.textContent = String(items.length);
      count.hidden = !items.length;
    });
  };
  const render = () => {
    grid.replaceChildren();
    empty.hidden = items.length > 0;
    items.forEach(item => {
      const card = document.createElement('article');
      card.className = 'zuqo-wishlist-saved';
      const link = document.createElement('a');
      link.href = item.url;
      if (typeof item.image === 'string' && /^(https:\/\/|\/\/|\/[^/])/.test(item.image)) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title;
        img.loading = 'lazy';
        img.width = 400;
        img.height = 400;
        link.append(img);
      }
      const title = document.createElement('h3');
      title.textContent = item.title;
      link.append(title);
      const price = document.createElement('p');
      price.textContent = item.price || '';
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'zuqo-wishlist-remove';
      remove.dataset.zuqoWishlistRemove = item.id;
      remove.textContent = 'Remove';
      remove.setAttribute('aria-label', `Remove ${item.title} from wishlist`);
      card.append(link, price, remove);
      grid.append(card);
    });
  };
  const persist = () => {
    let stored = true;
    try { localStorage.setItem(key, JSON.stringify(items)); } catch { stored = false; }
    update();
    if (dialog.open) render();
    return stored;
  };
  let opener;
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-zuqo-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      const data = toggle.dataset;
      if (!/^\d+$/.test(data.id) || !safePath(data.url)) return;
      const index = items.findIndex(item => item.id === data.id);
      if (index >= 0) items.splice(index, 1);
      else if (items.length < 200) items.push({id:data.id,title:data.title,url:data.url,price:data.price,image:data.image});
      else { status.textContent = 'Your wishlist is full. Remove an item to save another.'; return; }
      const stored = persist();
      status.textContent = stored ? `${data.title} ${index >= 0 ? 'removed from' : 'saved to'} wishlist.` : 'Wishlist updated for this visit. Your browser could not save it for later.';
      return;
    }
    const open = event.target.closest('[data-zuqo-wishlist-open]');
    if (open) {
      opener = open;
      render();
      if (!dialog.open) dialog.showModal();
      return;
    }
    const remove = event.target.closest('[data-zuqo-wishlist-remove]');
    if (remove) {
      items = items.filter(item => item.id !== remove.dataset.zuqoWishlistRemove);
      persist();
      dialog.querySelector('[data-zuqo-wishlist-close]').focus();
      status.textContent = 'Product removed from wishlist.';
    }
    if (event.target.closest('[data-zuqo-wishlist-close]')) dialog.close();
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => opener?.focus());
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    items = read();
    update();
    if (dialog.open) render();
  });
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;
      if (node.matches('[data-zuqo-wishlist-toggle]')) update(node.parentNode);
      else if (node.querySelector('[data-zuqo-wishlist-toggle]')) update(node);
    }));
  }).observe(document.body, {childList:true,subtree:true});
  update();
})();
